import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { useAppName, useLanguage, usePageState, useSitecoreApiHost, useSitecoreApiKey } from '../utils/sitecoreContext';
const useSitecoreLayoutService = (itemPath) => {
    var _a, _b;
    const [isFetching, setIsFetching] = useState(false);
    const [response, setResponse] = useState(null);
    const [placeholderName, setPlaceholderName] = useState();
    const [hasError, setHasError] = useState(false);
    const appName = useAppName();
    const language = useLanguage();
    const sitecoreApiHost = useSitecoreApiHost();
    const sitecoreApiKey = useSitecoreApiKey();
    const context = useSitecoreContext();
    const pageState = usePageState();
    const { layoutServiceRoute } = context.sitecoreContext;
    const scModeParam = pageState === 'preview' || pageState === 'edit' ? '&sc_mode=preview' : '';
    const url = `${sitecoreApiHost}${layoutServiceRoute}?item=${itemPath}&sc_lang=${language}&sc_apikey=${sitecoreApiKey}&sc_site=${appName}${scModeParam}`;
    useEffect(() => {
        if (!itemPath) {
            return;
        }
        setIsFetching(true);
        const fetchLayoutServiceItem = async () => {
            var _a, _b;
            try {
                const layoutServiceResponse = await axios(url);
                if (layoutServiceResponse === null || layoutServiceResponse === void 0 ? void 0 : layoutServiceResponse.data) {
                    const { data } = layoutServiceResponse;
                    setResponse(data);
                    const placeholderKeys = Object.keys((_b = (_a = data.sitecore) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.placeholders);
                    // By convention, the layout service routes we consume client-site have only one placeholder
                    setPlaceholderName(placeholderKeys[0]);
                }
                else {
                    setHasError(true);
                }
                setIsFetching(false);
            }
            catch (err) {
                setHasError(true);
                setIsFetching(false);
            }
        };
        fetchLayoutServiceItem();
    }, [itemPath, url]);
    const pageMetaData = (_b = (_a = response === null || response === void 0 ? void 0 : response.sitecore) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.pageMetaData;
    return {
        response,
        placeholderName,
        pageMetaData,
        isFetching,
        hasError,
    };
};
export default useSitecoreLayoutService;
